import { lazy, Suspense } from 'react';
import { createRoutesFromElements, Route } from 'react-router-dom';
import { LinearProgress } from '@zawarski/eti-ui';
import { MainLayout } from 'components/layout';
import { ErrorMessage } from 'components/fragment';

const Auth = lazy(() => import('@/auth'));
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const EventDetails = lazy(() => import('@/pages/EventDetails'));
const Registration = lazy(() => import('@/pages/Registration'));
const FolderList = lazy(() => import('@/pages/FileLibrary/TableList'));
const FileDetailList = lazy(() => import('@/pages/FileLibrary/DetailList'));

const routesConfig = () => {
  return createRoutesFromElements(
    <Route
      path='/'
      element={
        <Suspense fallback={<LinearProgress />}>
          <Auth />
        </Suspense>
      }>
      <Route path='dashboard' element={<MainLayout />}>
        <Route
          index
          element={
            <Suspense fallback={<LinearProgress />}>
              <Dashboard />
            </Suspense>
          }
        />
        <Route
          path='details/new'
          element={
            <Suspense fallback={<LinearProgress />}>
              <EventDetails newEntry={true} />
            </Suspense>
          }
        />
        <Route
          path='details/:id'
          element={
            <Suspense fallback={<LinearProgress />}>
              <EventDetails newEntry={false} />
            </Suspense>
          }
        />
        <Route path='filelibrary'>
          <Route
            index
            element={
              <Suspense fallback={<LinearProgress />}>
                <FolderList />
              </Suspense>
            }
          />
          <Route
            path='details/:date'
            element={
              <Suspense fallback={<LinearProgress />}>
                <FileDetailList />
              </Suspense>
            }
          />
        </Route>
      </Route>
      <Route path='registration'>
        <Route
          path={':eventId/:locationId'}
          element={
            <Suspense fallback={<LinearProgress />}>
              <Registration />
            </Suspense>
          }
        />
      </Route>
      <Route
        path='*'
        element={
          <div className={'ci:flex ci:w-screen ci:h-screen ci:items-center ci:justify-center'}>
            <ErrorMessage message={'Page Not Found'} />
          </div>
        }
      />
    </Route>
  );
};

export default routesConfig;
